import { ContainerName } from 'components/_hooks'
import React from 'react'
import { useOpenUserChat } from 'store/chat/chat/chat-hooks'
import { PublicUserType } from 'store/types/user-types'
import { cn } from 'utils'
import { SelfLoadedUserAvatar } from '../UserAvatar/UserAvatar'
import styles from  './FriendList.module.scss'

interface Props {
  user: PublicUserType,
  containerName?:ContainerName
}

const UserListRow = ({ user,containerName }: Props) => {
  const openUserChat = useOpenUserChat()

  const handleUserClick = () => {
    openUserChat(user.Id)
  }

  return (
    <div
      key={user.Id}
      className={styles.friendListRow}
      onClick={handleUserClick}
    >
      <div className="row" style={{ height: '40px' }}>
        <div className="col-4" style={{ paddingRight: '5px' }}>
          <SelfLoadedUserAvatar
            userId={user.Id}
            className={cn(styles.header__profilePicture, user.IsOnline && styles.active)}
            style={{ border: '0px' }}
            placeholder="user"
            containerName={containerName}
          />
        </div>
        <div className="col-6" style={{ paddingTop: '4px', paddingLeft: '0px' }}>
          <div className={cn('col-12',styles.headerProfileWrapper)}>
            <span className={styles.header__profileName}>{user.Username}</span>
          </div>
          <div className="col-12" style={{ padding: '0px' }}>
            {!user.IsOnline && <span className={styles.header__profileRankRed}>Offline</span>}
            {user.IsOnline && <span className={styles.header__profileRank}>Online</span>}
          </div>
        </div>
        <div className={cn('col-2', styles.chaticon)} />
      </div>
    </div>
  )
}

export default UserListRow
